export var LuxStatusV3Enum;
(function (LuxStatusV3Enum) {
    LuxStatusV3Enum["brand"] = "brand";
    LuxStatusV3Enum["neutral"] = "neutral";
    LuxStatusV3Enum["success"] = "success";
    LuxStatusV3Enum["warning"] = "warning";
    LuxStatusV3Enum["danger"] = "danger";
})(LuxStatusV3Enum || (LuxStatusV3Enum = {}));
export const LuxStatusKeysV3 = Object.keys(LuxStatusV3Enum);
export var LuxSizeEnum;
(function (LuxSizeEnum) {
    LuxSizeEnum["xs"] = "xs";
    LuxSizeEnum["sm"] = "sm";
    LuxSizeEnum["md"] = "md";
    LuxSizeEnum["lg"] = "lg";
    LuxSizeEnum["xl"] = "xl";
    LuxSizeEnum["xxl"] = "xxl";
})(LuxSizeEnum || (LuxSizeEnum = {}));
export const LuxSizeKeys = Object.keys(LuxSizeEnum);
export var LuxSurfaceEnum;
(function (LuxSurfaceEnum) {
    LuxSurfaceEnum["filled"] = "filled";
    LuxSurfaceEnum["outline"] = "outline";
    LuxSurfaceEnum["ghost"] = "ghost";
    LuxSurfaceEnum["ghostLink"] = "ghostLink";
})(LuxSurfaceEnum || (LuxSurfaceEnum = {}));
export const LuxSurfaceKeys = Object.keys(LuxSurfaceEnum);
export var LuxRoundedEnum;
(function (LuxRoundedEnum) {
    LuxRoundedEnum["none"] = "none";
    LuxRoundedEnum["xs"] = "xs";
    LuxRoundedEnum["sm"] = "sm";
    LuxRoundedEnum["md"] = "md";
    LuxRoundedEnum["lg"] = "lg";
    LuxRoundedEnum["xl"] = "xl";
    LuxRoundedEnum["full"] = "full";
})(LuxRoundedEnum || (LuxRoundedEnum = {}));
export const LuxRoundedKeys = Object.keys(LuxRoundedEnum);
export var LuxPaddingEnum;
(function (LuxPaddingEnum) {
    LuxPaddingEnum["none"] = "none";
    LuxPaddingEnum["xs"] = "xs";
    LuxPaddingEnum["sm"] = "sm";
    LuxPaddingEnum["md"] = "md";
    LuxPaddingEnum["lg"] = "lg";
    LuxPaddingEnum["xl"] = "xl";
})(LuxPaddingEnum || (LuxPaddingEnum = {}));
export const LuxPaddingKeys = Object.keys(LuxPaddingEnum);
//# sourceMappingURL=types.js.map